export default "Gang warfare has reached an all-time high in the Pacific Ocean. Which side will you choose?";